import React, {Component} from 'react';
import {connect} from 'react-redux';
import DrawerActions from './DrawerActions';
import DrawerTitle from './DrawerTitle';

import './drawer.css'

class Drawer extends Component{

    handleDrawer = () =>{
        if(this.props.isDrawerOpen){
            this.props.closeDrawer()
        }else{
            this.props.openDrawer()
        }
        this.props.toggleDrawerFix()
    }

    render(){
        return(
            <div 
                className={`mainDrawer ${this.props.isDrawerOpen? 'open' : ''} ${this.props.Dark? 'Dark' : ''}`}
                // onMouseEnter={() => this.props.openDrawer()}
                // onMouseLeave={() => this.props.isDrawerPin === false ? this.props.closeDrawer() : null}
            >
                <DrawerTitle title={this.props.title} onClose={()=>this.handleDrawer()}/>
                <div className="drawerItems">
                    {this.props.children}
                </div>
            </div>
        )
    }
}


const mapStateToProps = state =>{
    return { 
        isDrawerOpen: state.handleDrawer.isDrawerOpen,
        isDrawerFix: state.handleDrawer.isDrawerFix,
        isDrawerPin: state.handleDrawer.isDrawerPin
    }
}

export default connect(mapStateToProps, DrawerActions)(Drawer)